import { Type } from "class-transformer";
import { ReportSectionDto } from "@/core/features/report-sections/report-section.dto";
import { TechnicalReportDto } from "@/core/features/technical-reports/technical-report.dto";
import { TaskFileDto } from "@/core/features/task-files/task-file.dto";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class TechnicalReportSectionDto extends BaseEntityDto {
  @Type(() => TechnicalReportDto)
  technicalReport: TechnicalReportDto;
  technicalReportId: string;

  @Type(() => ReportSectionDto)
  reportSection: ReportSectionDto;
  reportSectionId: string;

  textValue?: string;

  @Type(() => TaskFileDto)
  taskFiles: TaskFileDto[];
}
